<ng-template
  #navigation
  let-navClass="navClass"
  let-buttonClass="buttonClass"
  let-indicatorClass="indicatorClass"
>
  <div [class]="navClass">
    <div [class]="buttonClass" role="button" aria-label="previous file">
      <rs-web-icon
        (click)="previousFile()"
        [color]="'#ffffff'"
        [icon]="ImmomioIconName.ChevronLeft"
      ></rs-web-icon>
    </div>
    <div [class]="'indicator-container ' + indicatorClass">
      @for (file of files(); track file.identifier; let index = $index) {
        <div
          role="button"
          (click)="setIndex(index)"
          [class.active]="file.identifier === currentFile()?.identifier"
          class="indicator-item"
        ></div>
      }
    </div>
    <div [class]="buttonClass" role="button" aria-label="next file">
      <rs-web-icon
        (click)="nextFile()"
        [color]="'#ffffff'"
        [icon]="ImmomioIconName.ChevronRight"
      ></rs-web-icon>
    </div>
  </div>
</ng-template>

@if (isCurrentFileUnavailable() || isCurrentFileRequested()) {
  <div class="requested-container">
    <div class="button-close" role="button" aria-label="close dialog">
      <rs-web-icon
        (click)="closeDialog()"
        [icon]="ImmomioIconName.Close"
        [color]="'#ffffff'"
      ></rs-web-icon>
    </div>
    <rs-web-file-requested-info
      (backToOverview)="closeDialog()"
      [isUnavailable]="isCurrentFileUnavailable()"
      [isRequested]="currentFile()?.isRequested"
      [isAlreadyRequested]="currentFile()?.isAlreadyRequested"
    ></rs-web-file-requested-info>
  </div>
} @else if (isLoading()) {
  <rs-web-loader [biggerSpinner]="true"></rs-web-loader>
} @else {
  @if (isCurrentFilePdf()) {
    <div class="pdf-container">
      <div class="pdf-header">
        <span class="pdf-filename">{{ currentFile()?.name }}</span>
        <div class="pdf-actions">
          <div class="pdf-button" role="button" aria-label="download file">
            <rs-web-icon
              (click)="onDownload()"
              [icon]="ImmomioIconName.Download"
              [color]="'#ffffff'"
            ></rs-web-icon>
          </div>
          <div class="pdf-button" role="button" aria-label="close dialog">
            <rs-web-icon
              (click)="closeDialog()"
              [icon]="ImmomioIconName.Close"
              [color]="'#ffffff'"
            ></rs-web-icon>
          </div>
        </div>
      </div>
      <iframe class="preview-pdf" [src]="currentFile()?.fileUrl"></iframe>
      @if (hasMultipleFiles()) {
        <ng-container
          *ngTemplateOutlet="
            navigation;
            context: {
              navClass: 'pdf-navigation',
              buttonClass: 'pdf-nav-button',
              indicatorClass: 'pdf-indicators',
            }
          "
        ></ng-container>
      }
    </div>
  } @else {
    <div class="image-container">
      <div class="image-header">
        <span class="image-filename">{{ currentFile()?.name }}</span>
        <div class="image-actions">
          <div class="image-button" role="button" aria-label="download file">
            <rs-web-icon
              (click)="onDownload()"
              [icon]="ImmomioIconName.Download"
              [color]="'#ffffff'"
            ></rs-web-icon>
          </div>
          <div class="image-button" role="button" aria-label="close dialog">
            <rs-web-icon
              (click)="closeDialog()"
              [icon]="ImmomioIconName.Close"
              [color]="'#ffffff'"
            ></rs-web-icon>
          </div>
        </div>
      </div>
      @if (isCurrentFileImage()) {
        <div class="image-content" [class.no-navigation]="!hasMultipleFiles()">
          <img class="preview-image" alt="" [src]="currentFile()?.fileUrl" />
        </div>
      }
      @if (hasMultipleFiles()) {
        <ng-container
          *ngTemplateOutlet="
            navigation;
            context: {
              navClass: 'image-navigation',
              buttonClass: 'image-nav-button',
              indicatorClass: 'image-indicators',
            }
          "
        ></ng-container>
      }
    </div>
  }
}
